
import { FormControl } from '@angular/forms';


export function requiredBoundFieldValidator(boundToControlName: string) {

  let thisControl: FormControl;
  let boundControl: FormControl;

  return function notHiddenAndNotEmptyValidate(control: FormControl) {

    if (!control.parent) {
      return null;
    }

    // Initializing the validator.
    if (!thisControl) {
      thisControl = control;
      boundControl = control.parent.get(boundToControlName) as FormControl;
      if (!boundControl) {
        throw new Error('requiredBoundFieldValidator(): bound control is not found in parent group');
      }
    }

    if (!boundControl) {
      return null;
    }

    if (boundControl.value && !thisControl.value) {
      return {
        boundToControlNotFilled: true
      };
    }

    return null;

  };

}
